var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "400"
    },
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-card', {
    staticClass: "common-message-dialog"
  }, [_vm.title ? _c('v-card-title', {
    staticClass: "common-message-dialog__title justify-center text-center"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]) : _vm._e(), _c('v-card-text', {
    staticClass: "common-message-dialog__info text-center"
  }, _vm._l(_vm.lines, function (line, index) {
    return _c('p', {
      key: index
    }, [_vm._v(_vm._s(line))]);
  }), 0), _c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.exit
    }
  }, [_vm._v(" " + _vm._s(_vm.confirmText) + " ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }